module.exports = __webpack_public_path__ + "img/donut_chart.ebbb718f.svg";